import { render, staticRenderFns } from "./portalContentDialog.vue?vue&type=template&id=101dfc1e&lang=pug"
import script from "./portalContentDialog.vue?vue&type=script&lang=js"
export * from "./portalContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports